module.exports = require("@react-keycloak/web");